import { render, staticRenderFns } from "./BrandI18n.vue?vue&type=template&id=d2ef50c0&scoped=true"
import script from "./BrandI18n.vue?vue&type=script&lang=js"
export * from "./BrandI18n.vue?vue&type=script&lang=js"
import style0 from "./BrandI18n.vue?vue&type=style&index=0&id=d2ef50c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2ef50c0",
  null
  
)

export default component.exports